import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { DEFAULT_CATEGORY_LIST, DEFAULT_CATEGORY_NAMES, DEFAULT_CATEGORY_COLORS } from "@/lib/categories";

const CategoriesContext = createContext({
  list: DEFAULT_CATEGORY_LIST,
  categories: DEFAULT_CATEGORY_NAMES,
  colors: DEFAULT_CATEGORY_COLORS,
  refresh: () => {},
});

export function CategoriesProvider({ children }) {
  const [list, setList] = useState(null);
  const load = () => api.get("/categories").then((r) => setCatsSafe(r.data)).catch(() => {});
  const setCatsSafe = (data) => {
    if (Array.isArray(data) && data.length && data.every((c) => c && c.name)) setList(data);
  };
  useEffect(() => { load(); }, []);

  const value = useMemo(() => {
    const l = list || DEFAULT_CATEGORY_LIST;
    return {
      list: l,
      categories: l.map((c) => c.name),
      colors: Object.fromEntries(l.map((c) => [c.name, c.color])),
      refresh: load,
    };
  }, [list]);

  return <CategoriesContext.Provider value={value}>{children}</CategoriesContext.Provider>;
}

export const useCategories = () => useContext(CategoriesContext);
